import { useEffect, useState, type RefObject } from "react";

function isFormFieldElement(el: Element | null): boolean {
  if (!el || !(el instanceof HTMLElement)) return false;
  const { tagName } = el;
  if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT") {
    return true;
  }
  return el.isContentEditable;
}

function isInsideScope(
  scopeRef: RefObject<HTMLElement | null>,
  el: Element | null,
): boolean {
  const root = scopeRef.current;
  if (!root || !el) return false;
  return root.contains(el);
}

/** scopeRef 내부 폼 필드 포커스 시 true (하단 CTA 숨김·min-height 보강 등) */
export function useHideBottomFixedForKeyboard(
  scopeRef: RefObject<HTMLElement | null>,
): boolean {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const onFocusIn = (e: FocusEvent) => {
      const t = e.target as Element;
      if (isFormFieldElement(t) && isInsideScope(scopeRef, t)) {
        setHidden(true);
      }
    };

    const onFocusOut = () => {
      window.setTimeout(() => {
        const ae = document.activeElement;
        setHidden(isFormFieldElement(ae) && isInsideScope(scopeRef, ae));
      }, 0);
    };

    document.addEventListener("focusin", onFocusIn, true);
    document.addEventListener("focusout", onFocusOut, true);

    return () => {
      document.removeEventListener("focusin", onFocusIn, true);
      document.removeEventListener("focusout", onFocusOut, true);
    };
  }, [scopeRef]);

  return hidden;
}
